import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { LanguageProvider } from './contexts/LanguageContext';
import Header from './components/Header';
import HomePage from './components/HomePage';
import AuthModal from './components/AuthModal';
import ModuleDetail from './components/ModuleDetail';
import TestPage from './components/TestPage';
import ProfilePage from './components/ProfilePage';
import QuickTest from './components/QuickTest';
import ModulesPage from './components/ModulesPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import ContactPage from './pages/ContactPage';
import './theme.css';
import './App.css';
import './i18n/config';

function App() {
  // Add global listener for language changes
  useEffect(() => {
    const syncLanguage = () => {
      // When language is changed, ensure HTML lang attribute reflects it
      const storedLanguage = localStorage.getItem('language') || 'en';
      document.documentElement.setAttribute('lang', storedLanguage);
      
      // Optional: Force any lazy-loaded libraries to reload with new language
      const event = new Event('languageSync');
      window.dispatchEvent(event);
    };

    // Listen for storage events (if language is changed in another tab)
    window.addEventListener('storage', (e) => {
      if (e.key === 'language') {
        syncLanguage();
      }
    });

    // Initial sync
    syncLanguage();

    return () => {
      window.removeEventListener('storage', syncLanguage);
    };
  }, []);

  return (
    <Router>
      <LanguageProvider>
        <ThemeProvider>
          <AuthProvider>
            <div className="App">
              <Header />
              <main className="main-content">
                <Routes>
                  <Route path="/" element={<AuthModal />} />
                  <Route path="/authmodal" element={<AuthModal />} />
                  <Route path="/home" element={<HomePage />} />
                  <Route path="/module/:moduleId" element={<ModuleDetail />} />
                  <Route path="/modules" element={<ModulesPage />} />
                  <Route path="/test/:testId" element={<TestPage />} />
                  <Route path="/profile" element={<ProfilePage />} />
                  <Route path="/quick-test" element={<QuickTest />} />
                  <Route path="/privacy" element={<PrivacyPage />} />
                  <Route path="/terms" element={<TermsPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                </Routes>
              </main>
            </div>
          </AuthProvider>
        </ThemeProvider>
      </LanguageProvider>
    </Router>
  );
}

export default App;
